module.exports = __webpack_public_path__ + "/images/embarazada-p-1080.e4a47a2.jpeg";